module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This work is dedicated to all animal lovers, especially those who have adopted and saved a life in need. We have dedicated over five years of our life building a community hand in hand with you, our incredible fans. Thank you for your continued support and humane treatment of our animal friends.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca69586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04dedication.vue
// module id = 66
// module chunks = 0